
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pageSlug]/[...taxonomies]",
      function () {
        return require("private-next-pages/[pageSlug]/[...taxonomies].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pageSlug]/[...taxonomies]"])
      });
    }
  